import React, { useEffect, useRef, useState } from "react";
import profile from "../../assets/images/Abdulluah-Talent.png";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import Image from "../Image";
import { HiOutlineBell } from "react-icons/hi2";
import { useUser } from "../../context/UserContext";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const companyData = JSON.parse(localStorage.getItem('company'));
  const menuRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  // const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { profileData, notifications, refreshProfile, refreshNotifications } = useUser();
  const { t, i18n } = useTranslation();
  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
  };
  // const fetchNotifications = async (page = 1) => {
  //   try {
  //     setIsLoading(true);
  //     const res = await ApiService.request({
  //       method: "GET",
  //       url: `company/getNotifications?page=${page}`,
  //     });

  //     const data = res.data;
  //     if (data.status) {
  //       setNotifications(data?.data?.notifications || []); 
  //     } else {
  //       toast.error(data.message);
  //     }
  //   } catch (err) {
  //     console.error("Fetch Notification Error:", err);
  //     toast.error("Failed to fetch notifications.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchNotifications(1);
  // }, []);
  const onCompanySignOut = async () => {
    try {
      const response = await ApiService.request({
        method: "POST",
        url: `/company/logout`,
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        localStorage.clear();
        navigate("/");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log("Error on User SignOut :- ", error);
    }
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setShowDropdown(false);
    }

    if (
      menuRef.current &&
      !menuRef.current.contains(event.target)
    ) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const dropdownRef = useRef(null);
  useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  useEffect(() => {
    const currentLang = i18n.language;
    const direction = currentLang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", currentLang);
  }, [i18n.language]);
  // const fetchProfile = async () => {
  //   try {
  //     const response = await ApiService.request({
  //       method: "GET",
  //       url: `/company/getProfile`,
  //     });
  //     const data = response.data;
  //     if (data.status) {
  //       setProfileData(data.data.company);
  //     } else {
  //       toast.error(data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching profile:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchProfile();
  // }, []);

  // const [profileData, setProfileData] = useState(null);

  return (
    <nav
      className="inter-font py-2 px-4 bg-transparent"
    style={{ background: "transparent" }}
    
    >
    <b className="float-start mt-3 d-flex align-items-center">
        Welcome, {profileData?.company_name || "Company Name"} 
        <span className="badge bg-dark mx-3">Company</span>
        {profileData?.approval_status && profileData?.approval_status !== "Approved" && (
            <span className={`badge ms-2 ${profileData?.approval_status === 'Rejected' ? 'bg-danger' : 'bg-warning text-dark'}`} style={{fontSize: '0.8rem'}}>
                {profileData?.approval_status}
            </span>
        )}

    </b>
      {/* <button
        className="inter-font navbar-toggler ms-auto "
        type="button"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span className="inter-font navbar-toggler-icon"></span>
      </button> */}

      {/* <div
  // ref={menuRef}
  className={`inter-font  start-0 end-0  collapse navbar-collapse ${menuOpen ? " position-absolute top-100" : ""}`}
  style={{ zIndex: 999, minWidth: "200px" }}
>      */}
   <ul className="inter-font list-unstyled d-flex justify-content-end align-items-center m-0">
     <li className="inter-font mx-3">
          <div
            onClick={() =>
              handleLanguageChange(i18n.language === "en" ? "ar" : "en")
            }
            // className={inter-font `lang-item ${
            //   i18n.language === lang.code ? "active-lang" : ""
            // }`}
            style={{
              cursor: "pointer",
              padding: "8px 15px",
              borderRadius: "10px",
              backgroundColor: "#6d5f27",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "15px",
            }}
          >
            {i18n.language === "en" ? "العربية" : "English"}
          </div>

        </li>
          <li className="inter-font nav-item inter-font">
            <Link to={"/company/dashboard"} className="inter-font nav-link" >
              {t("home")}
            </Link>
          </li>
          <li className="inter-font nav-item mx-md-4 mx-2 inter-font">
            <Link to={"/company/talents"} className="inter-font nav-link">
              {t("c_s_tab6")}
            </Link>
          </li>
          {/* <li className="inter-font nav-item me-md-4 me-2 inter-font">
            <Link to={"/company/notification"} className="inter-font nav-link" >
              Notification
            </Link>
          </li> */}
           <li
                    className="inter-font mx-3 position-relative"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() =>
                      navigate("/company/notification")
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <HiOutlineBell
                      style={{
                        fontSize: "24px",
                        color: isHovered ? "#CD496D" : "#333",
                        transition: "color 0.3s",
                      }}
                    />
                    {notifications.unread_count > 0 && 
                     <span
                     className="inter-font position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                     style={{ fontSize: "10px", padding: "2px 6px" }}
                   >
                     {notifications.unread_count}
                   </span>
                    }
                   
                  </li>

          <li className="inter-font nav-item position-relative">

              <Image
                src={profileData?.logo}
                // style={{ width: "60px", cursor: "pointer" }}
                onClick={() => setShowDropdown(!showDropdown)}
                alt="Profile"
                className="inter-font rounded-circle ms-2"
                style={{ width: "52px", borderRadius: "50%", height: "52px", cursor: "pointer", border: "1px solid #d3d3d3", }}
              />

            {showDropdown && (
              <div
                ref={dropdownRef}
                className={`inter-font position-absolute top-100 mt-2 bg-white shadow rounded-3 p-2 ${
      document.dir === 'rtl' ? 'start-0' : 'end-0'
    }`}
                style={{ width: "260px", zIndex: 1000 }}
              >
                <div className="inter-font d-flex gap-3">
                    <Image
                      src={profileData?.logo}
                      style={{ width: "52px", borderRadius: "50%", height: "52px",  border: "1px solid #d3d3d3", }}
                      alt="Profile"
                    />

                  <div className="inter-font ">
                    <div className="inter-font fw-bold mt-2"> {profileData?.company_name || ""}</div>
                    <div className="inter-font text-muted" style={{ fontSize: "14px" }}>
                    {profileData?.category_id?.title || ""}
                    </div>
                  </div>
                </div>

                <div className="inter-font text-center p-3">
                  <button
                    className="inter-font btn btn-sm mt-2 w-100 inter-font text-white py-2"
                    style={{ backgroundColor: "rgb(231, 142, 123)" }}
                    onClick={() => navigate("/company/profile")}

                  >
                    {t("c_s_tab10")}
                  </button>
                </div>

                {/* <div className="inter-font px-3 py-2">
                  <div className="inter-font fw-bold mb-1">Account</div>
                  <ul
                    className="inter-font text-muted list-unstyled inter-font"
                    style={{ fontSize: "14px", cursor: "pointer" }}
                  >
                    <li>Settings & Privacy</li>
                    <li className="inter-font my-2">Help</li>
                    <li>Language</li>
                  </ul>
                </div> */}

                {/* <div className="inter-font px-3 py-2 border-bottom">
                  <div className="inter-font fw-bold mb-1">Manage</div>
                  <ul
                    className="inter-font text-muted list-unstyled inter-font"
                    style={{ fontSize: "14px", cursor: "pointer" }}
                  >
                    <li>Posts & Activity</li>
                    <li className="inter-font mt-2">Job Posting Account</li>
                  </ul>
                </div> */}

                <div
                  className="inter-font px-3 py-2 text-danger"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={() => onCompanySignOut()}
                >
                  {t("new_text_20")}
                </div>
              </div>
            )}
          </li>
        </ul>
      {/* </div> */}
    </nav>
  );
};

export default Navbar;
